export const formatDate = (date: string | undefined) => {
  if (!date) return '';
  // 2023/10/19 9:32:11の文字列を2023/10/19にする
  return date.split(' ')[0];
};

/**
 * ISO 8601形式の時刻フォーマットを変換
 * @param dateTime yyyy-MM-ddTHH:mm:ss+z
 * @returns
 */
export const formatDateTimeToSlashDateTime = (dateTime: string | undefined) => {
  if (!dateTime) return '';

  const dateTimeMatch = dateTime.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
  if (!dateTimeMatch) return '';

  const [, year, month, day, hour, minute, second] = dateTimeMatch;
  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
};

export const formatDateSlashToJapanese = (dateString: string | undefined) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; //月は0から始まるため+1
  const day = date.getDate();

  return `${year}年${month}月${day}日`;
};

export const formatDateToSlashDateTime = (dateString: string | undefined, withTime: boolean = true) => {
  if (!dateString) return '';

  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  if (withTime) return `${year}/${month}/${day} ${hour}:${minute}`;

  return `${year}/${month}/${day}`;
};

export const formatDateTime = (dateTimeString: string | undefined) => {
  if (!dateTimeString) return '';
  const date = new Date(dateTimeString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; //月は0から始まるため+1
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  return `${year}/${month}/${day} ${hours}:${minutes}`;
};
